<template>
    <plantilla-contenido>
        <div slot="titulo">
            <i class="fas fa-home icon"></i>
            Mantenedor de camas
            </div>
            <div slot="breadCrumb">
            <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                <li>
                    <router-link :to="{ name: 'administratorReport' }">
                    <span class="has-text-black">
                        <i class="fas fa-home icon"></i>
                        inicio
                    </span>
                    </router-link>
                </li>
                <li class="is-active">
                    <router-link :to="{ name: 'administratorBedsManteiner' }">
                    <span class="has-text-black">
                        <i class="fas fa-bed"></i>
                        Camas
                    </span>
                    </router-link>
                </li>
                </ul>
            </nav>
        </div>
        <div slot="contenido">
            <button-create-bed></button-create-bed>
            <br><br>
            <beds></beds>
        </div>
    </plantilla-contenido>
</template>    
<script>
import Beds from '../../../components/mantainers/bed/Beds.vue';
import ButtonCreateBed from '../../../components/mantainers/bed/ButtonCreateBed.vue';
import PlantillaContenido from '../../../template/PlantillaContenido';
export default {
    components:{
        PlantillaContenido,
        Beds,
        ButtonCreateBed,
    }
    
}
</script>        